import React, { Children } from 'react';
import { fluidSectionsStyles } from './styles';

/*

Props:
• sectionMinWidth
• sectionMaxWidth,
• backgroundColor

*/
let componentStyles = {...fluidSectionsStyles}; // Clone original styles and use the clone

const _applyStyleModifiers = (props) => {
    const { sectionMinWidth, sectionMaxWidth, sectionMarginBottom } = props;
    let { subSection, container, outerContainer } = componentStyles; 

    if (sectionMinWidth) {
        subSection = { ...subSection, minWidth: sectionMinWidth};
    }
    if (sectionMaxWidth) {
        subSection = { ...subSection, maxWidth: sectionMaxWidth};
    }
    
    if (props.style){
        container = { ...container, ...props.style };
    }
    if (props.backgroundColor) {
        outerContainer = {...outerContainer, backgroundColor: props.backgroundColor}
    }
    return {...fluidSectionsStyles, subSection, container, outerContainer};
}

export const FluidSection = (props) => {
    
    const styles = _applyStyleModifiers(props);
    const childNum = React.Children.count(props.children);
    return (
        <div className="FluidSection-outerContainer" style={styles.outerContainer}>
            <div className="FluidSection-innerContainer" style={styles.container}>
                { (childNum > 0) && React.Children.map(props.children, (child, i) => {
                    return (
                        <div className="FluidSection-subSection" style={styles.subSection}>
                            {child}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/js/components/FluidSection/FluidSection.jsx